<template>
  <div>
    <div id="page-header" />

    <div align="center">
      <div id="center-logo">
        <img alt="InCrowd logo" src="@/assets/logo.png">
      </div>

      <verify-account-page v-if="isVerify" />
      <reset-password-form v-else-if="isResetPassword" />
      <template v-else>
        <login-form @show-view="showView" @logged-in="loggedIn" v-show="view == 0" />
        <register-form @back-to-login="backToLogin" v-show="view == 1" />
        <forgotten-password @back-to-login="backToLogin" v-show="view == 2" />
      </template>
      
      <div class="page-footer" />
    </div>
  </div>
</template>

<script>
import ResetPasswordForm from './ResetPasswordForm.vue'
import LoginForm from './LoginForm.vue'
import RegisterForm from './RegisterForm.vue'
import ForgottenPassword from './ForgottenPassword.vue'
import VerifyAccountPage from './VerifyAccountPage.vue'

export default {
  components: {
    ResetPasswordForm,
    VerifyAccountPage,
    LoginForm,
    RegisterForm,
    ForgottenPassword,
  },
  mounted() {
    this.isVerify = window.location.href.includes('/verify')
    this.isResetPassword = window.location.href.includes('/reset-password')
  },
  data(){
    return {
      view: 0, // 0 = login, 1 = register, 2 = forgotten password,
      isVerify: false,
      isResetPassword: false
    }
  },
  methods: {
    showView(view) {
      this.view = view;
    },
    loggedIn(email, accessToken) {
        this.$emit('logged-in', email, accessToken)
    },
    backToLogin() {
      this.view = 0;
    }
  }
}
</script>

<style>
#page-header {
  width: 100%;
  min-height: 62px;
  background: rgba(35, 37, 45, 1);
}
#center-logo {
  margin-top: 54px;
}
.login-form {
  padding: 32px;
  max-width: 448px;
  margin-top: 24px;
  margin-left: 16px;
  margin-right: 16px;

  background: #23252D;

  border: 1px solid rgba(73, 76, 85, 1);
  box-sizing: border-box;
  border-radius: 4px;
}
.input-form {
  width: 100%;
  max-width: 384px;
}
.input-label {
  text-align: left;
}
.input {
  width: 100%;
  height: 40px;
  margin-top: -8px;

  background-color: rgba(73, 76, 85, 1);
  color: white;
   
  border: 1px solid rgba(89, 92, 102, 1);
  border-radius: 4px;
}
.input:focus {
  background-color: rgba(73, 76, 85, 1);

  border: 1px solid white;
  border-radius: 4px;
}
.password-input-group {
  margin-top: 32px;
}
.form-button {
  background-color: rgba(73, 76, 85, 1);
  margin-top: 32px;
  width: 100%;
  height: 38px;
  
  border: 1px solid rgba(89, 92, 102, 1);
  border-radius: 4px;
}
.form-button:hover, .form-button:focus {
  background-color: rgba(73, 76, 85, 1);

  border: 1px solid rgba(89, 92, 102, 1);
  border-radius: 4px;
}
#forgot-password-button {
  width: fit-content;
  margin-top: 32px;
  text-decoration-line: underline;
  cursor: pointer;
}
#register-text {
  width: fit-content;
}
#register-button {
  cursor: pointer;
}
.invalid-label {
  margin-top: 8px;
  text-align: left;
}
.invalid-label img {
  margin-right: 4px;
}

.form-button, #forgot-password-button, /* LoginForm */
.create-account-title, /* RegisterForm */
.register-successful-title, /* RegisterSuccessful */
.forgotten-password-title, /* ForgottenPassword */
.reset-password-successful-title, /* ResetPasswordSuccessful */
.header-buttons, .download-cast-button, .empty-warning, /* OrganisationForm */
.licence-info-title, #download-button, /* LicenceDetails */
.reset-password-text, /* ResetPasswordForm */
.verify-account-text /* VerifyAccountPage */ {
  /* Desktop/Body Medium */
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;

  color:white;
}
.reset-password-title, /* ResetPasswordForm */
.verify-account-title /* VerifyAccountPage */ {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  line-height: 22.27px;
  text-align: left;

  color:white;
}
p,
.input-label, .input, #register-text, #register-button, .invalid-label, /* LoginForm */
.back-to-login-button, /* RegisterForm */
.search-bar, .organisation-name, /* OrganisationForm */
.back-button, .licence-name /* OrganisationForm */ {
  /* Desktop/Body Regular */
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color:white;
}
@media screen and (max-width: 475px) {
  .form-button, #forgot-password-button, /* LoginForm */
  .create-account-title, /* RegisterForm */
  .register-successful-title, /* RegisterSuccessful */
  .forgotten-password-title, /* ForgottenPassword */
  .reset-password-successful-title, /* ResetPasswordSuccessful */
  #logout-button, .empty-warning, /* OrganisationForm */
  .licence-info-title, #download-button /* LicenceDetails */ {
    /* Desktop/Body Medium */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;

    color:white;
  }
  p,
  .input-label, .input, #register-text, #register-button, .invalid-label, /* LoginForm */
  .back-to-login-button, /* RegisterForm */
  .search-bar, .organisation-name, /* OrganisationForm */
  .back-button, .licence-name /* OrganisationForm */ {
    /* Desktop/Body Regular */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color:white;
  }
}
</style>